<template>
  <div class="container">
    <div class="block">
      <div class="content-inner-wrapper">
        <h3>服务器设置</h3>
        <van-field class="payment" label="申请类型">
          <template #input>
            <van-button
              :class="{ active: paymentType === '0' }"
              @click="paymentType = '0'"
              >全部</van-button
            >
            <van-button
              :class="{ active: paymentType === '4' }"
              @click="paymentType = '4'"
              >支付宝</van-button
            >
            <van-button
              :class="{ active: paymentType === '3' }"
              @click="paymentType = '3'"
              >微信</van-button
            >
          </template>
        </van-field>
        <date-selector
          v-model="formInline.date"
          :queryBtnClick="queryTableFn"
        ></date-selector>
        <my-table :tableData="orderList" :tableField="dataField">
          <template slot-scope="scope" slot="default">
            <span v-if="scope.row.key == 'day'"> {{ scope.row.value }}天 </span>
            <span v-else-if="scope.row.key == 'player_max'">
              最多容纳{{ scope.row.value }}人
            </span>
            <span v-else-if="scope.row.key == 'money'">
              {{ scope.row.value | twoDigit }}
            </span>
            <span v-else-if="scope.row.key == 'buy_type'">
              {{ scope.row | payType }}
            </span>
            <span v-else-if="scope.row.key == 'operation_type'">
              {{ scope.row.value | orderType }}
            </span>
            <span v-else-if="scope.row.key == 'state'">
              {{ scope.row.value | orderState }}
            </span>
          </template>
          <template slot-scope="scope" slot="opt-slot">
            <a
              class="table_option"
              @click="
                $router.push({
                  name: 'cloudServerOrderDetails',
                  params: { order: scope.row, id: scope.row.id },
                })
              "
              href="javascript:void(0);"
              >查看详情</a
            >
          </template>
        </my-table>
        <van-pagination
          v-model="pagination.page"
          :force-ellipses="true"
          @change="paginationChange"
          :total-items="pagination.total"
          :show-page-size="5"
        >
          <template #prev-text>
            <van-icon name="arrow-left" />
          </template>
          <template #next-text>
            <van-icon name="arrow" />
          </template>
          <template #page="{ text }">{{ text }}</template>
        </van-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import DateSelector from '../../components/m/DateSelector.vue';
import MyTable from '../../components/m/MyTable.vue';
import { ONE_DAY, TO_DAY } from '../../base/CONST';
import mixins from '../../mixins/orderList.mixins';
export default {
  mixins: [mixins],
  components: {
    DateSelector,
    MyTable,
  },
  data() {
    return {
      DateArr: [TO_DAY - 7 * ONE_DAY, TO_DAY],
      dataField: [
        { prop: 'id', label: '订单号' },
        { prop: '', label: '' },
        { prop: 'create_time', label: '订单时间' },
        { prop: 'player_max', label: '服务器规格' },
        // { prop: 'servType', label: '服务器类型' },
        { prop: 'day', label: '购买时长' },
        { prop: 'buy_count', label: '购买数量' },
        { prop: 'money', label: '金额' },
        { prop: 'buy_type', label: '支付方式' },
        { prop: 'operation_type', label: '订单类型' },
        { prop: 'state', label: '交易状态' },
        { prop: 'operation', label: '查看详情' },
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      //购买记录页曝光埋点
      this.$log('record_purchase_show', 85439, { v7: 2 });
    },
  },
};
</script>
<style src="../../style/common-m.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.van-button {
  height: 64px;
  background: #fff;
  border-radius: 7px;
  border: 2px solid #e1e1e1;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #323232;
  line-height: 36px;
  margin-right: 24px;
  &.active {
    border-color: #ffcc40;
    background-color: #fff9eb;
  }
}
div.recordType {
  margin: 32px auto 24px;
}
.payment {
  padding: 0;
  margin-bottom: 24px;
  ::v-deep .van-cell__title {
    width: 120px;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #262626;
  }
}
::v-deep .table-wrap {
  tr {
    .fixed-td {
      max-width: 1.7rem;
      width: 1.7rem;
    }
    .hidden-td {
      width: 1.7rem;
    }
    .table_option {
      color: #50a3f1;
    }
  }
}
</style>
